import { fetchDocumentHtml } from "./download";
import { printHtml } from "./hardware";

/**
 * Prints an A4 document (invoice, Z-report, payslip…). In the Electron POS it goes straight to the configured document printer with
 * NO print dialog (nothing for the cashier to click, nothing to pile up in a queue). In a plain browser the normal print dialog is the only option.
 */
export async function printDocument(path: string): Promise<"silent" | "dialog"> {
  const html = await fetchDocumentHtml(path);
  if (window.hardware?.printDocument) {
    await window.hardware.printDocument(html);
    return "silent";
  }
  printHtml(html);
  return "dialog";
}
